import axios from '@axios'

export default {
  namespaced: true,
  actions: {

    getPlanComments(ctx,params) {
      return new Promise((resolve, reject) => {
        axios.get(`comments`,{params})
          .then(res => resolve(res.data))
          .catch(reason => reject(reason.response))
      })
    },
    fetchPlans(ctx, queryParams) {
     // console.log('ttt data is ',queryParams)
      return new Promise((resolve, reject) => {
        axios.get('plans', { params: queryParams })
          .then(response => {
            
            resolve(response)
          
          })
          .catch(error => reject(error))
      })
    },

    createPlan(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.post('plans',form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    updatePlan(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.put(`plans/${form.id}`,form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchPlan(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.get(`plans/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
   deletePlan(ctx,params) {
    return new Promise((resolve, reject) => {
      axios.delete(`plans/${params.id}?type=${params.PlanType}`)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }
}
